import { render } from "./pagination-simple.vue?vue&type=template&id=0381b3fc"
import script from "./pagination-simple.vue?vue&type=script&lang=js"
export * from "./pagination-simple.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__